import { useState } from 'react';
import { ErrorBoundary } from 'react-error-boundary';

export default function AppErrorBoundary({ children }) {

    const [showDetails, setShowDetails] = useState(false);

    function onReset(reset) {
        // if(reset) reset();
        // else window.location.reload();
        window.location.reload();
    }

    return (
        <ErrorBoundary
            onError={(error, info) => {
                console.error(error, info);
            }}
            fallbackRender={({ error, resetErrorBoundary }) => (
                <div className={`inset-0 flex items-center justify-center bg-white z-50 text-black fixed`}>
                    <div className={`w-1/2 p-6 bg-white border-2 border-black border-t-4 z-10 min-w-fit normal-case border-t-red-600`}>
                        <h3 className="text-2xl">Whoops!</h3>
                        <div className='p-4'>
                            <p className="font-bold text-xl">Sorry, something went wrong.</p>
                            <p className="text-lg mb-4">Something unexpected happened and we couldn't recover.</p>
                            <button className="btn-invert" onClick={() => onReset(resetErrorBoundary)}>Try Again</button>
                        </div>

                        <button onClick={()=>setShowDetails(s=>!s)} className='font-mono text-gray-300 text-sm'>({showDetails?'Hide':'Show'} Details)</button>
                        {showDetails && (
                            <div className="border border-black shadow text-left p-4 bg-gray-100 text-gray-600">
                                <h4 className='text-xl'>Details</h4>
                                <div className="p-4 font-mono">
                                    <p className='block text-md'>{error.name || "Unknown Error"}: {error.message || "An unknown error occurred"}</p>
                                    {error.code && (<div className="p-4 bg-gray-300">
                                        <p className="text-gray-500 overflow-y-auto overflow-x-hidden whitespace-pre-line text-ellipsis">(Code: {error.code})</p>
                                    </div>)}
                                    <hr className='border-b border-gray-400 my-4' />
                                    <p className='text-xs font-light'>If you plan on reporting this incident, make sure to include these details!</p>
                                </div>
                            </div>
                        )}
                    </div>
                </div>

            )}>
            {children}
        </ErrorBoundary>
    );

}